export default __webpack_public_path__ + "static/media/businessPlanLogo.1382e7e5.svg";